import { http } from '@/support/axios'

export default {
  actions: {
    attemptSubmitSurvey (_, payload) {
      return http.post('v1/survey/answer', payload)
    }
  }
}
